var shadowCoordPS = `
void _getShadowCoordOrtho(mat4 shadowMatrix, vec3 shadowParams, vec3 wPos) {
		dShadowCoord = (shadowMatrix * vec4(wPos, 1.0)).xyz;
		dShadowCoord.z = saturate(dShadowCoord.z) - 0.0001;

		#ifdef SHADOWBIAS
		dShadowCoord.z += getShadowBias(shadowParams.x, shadowParams.z);
		#endif
}

void _getShadowCoordPersp(mat4 shadowMatrix, vec4 shadowParams, vec3 wPos) {
		vec4 projPos = shadowMatrix * vec4(wPos, 1.0);
		projPos.xy /= projPos.w;
		dShadowCoord.xy = projPos.xy;
		dShadowCoord.z = length(dLightDirW) * shadowParams.w;

		#ifdef SHADOWBIAS
		dShadowCoord.z += getShadowBias(shadowParams.x, shadowParams.z);
		#endif
}

void getShadowCoordOrtho(mat4 shadowMatrix, vec3 shadowParams) {
		_getShadowCoordOrtho(shadowMatrix, shadowParams, vPositionW);
}

void getShadowCoordPersp(mat4 shadowMatrix, vec4 shadowParams) {
		_getShadowCoordPersp(shadowMatrix, shadowParams, vPositionW);
}

void getShadowCoordPerspNormalOffset(mat4 shadowMatrix, vec4 shadowParams) {
		float distScale = abs(dot(vPositionW - dLightPosW, dLightDirNormW)); // fov?
		vec3 wPos = vPositionW + dVertexNormalW * shadowParams.y * clamp(1.0 - dot(dVertexNormalW, -dLightDirNormW), 0.0, 1.0) * distScale;

		_getShadowCoordPersp(shadowMatrix, shadowParams, wPos);
}

void getShadowCoordOrthoNormalOffset(mat4 shadowMatrix, vec3 shadowParams) {
		vec3 wPos = vPositionW + dVertexNormalW * shadowParams.y * clamp(1.0 - dot(dVertexNormalW, -dLightDirNormW), 0.0, 1.0); //0.08

		_getShadowCoordOrtho(shadowMatrix, shadowParams, wPos);
}
`;

export { shadowCoordPS as default };
